import { RouteProps } from "react-router"
import { Tメニュー分類コード, メニュー分類 } from "./categories"
import {
  Ayanas_Queryメニューコード,
  トップメニューコード,
  マスタ管理メニューコード,
  乗務員管理メニューコード,
  予算_実績メニューコード,
  勤怠管理メニューコード,
  受注配車メニューコード,
  海コン受注配車メニューコード,
  給与管理メニューコード,
  請求_支払管理メニューコード,
  購買管理メニューコード,
  車輌管理メニューコード,
  運行管理メニューコード,
} from "./menuCode"
// トップ
import Top from "../features/Top/Top"
// 受注配車
import HaisyaRegister from "../features/Order/HaisyaRegister/HaisyaRegister"
import SyabanRenrakuhyo from "../features/Order/SyabanRenrakuhyo/SyabanRenrakuhyo"
import UnsogyomuHatyusyo from "../features/Order/UnsogyomuHatyusyo/UnsogyomuHatyusyo"
import ZyutyuHaisyaList from "../features/Order/ZyutyuHaisyaList/ZyutyuHaisyaList"
import ZyutyuHaisyaPatternList from "../features/Order/ZyutyuHaisyaPatternList/ZyutyuHaisyaPatternList"
import ZyutyuHaisyaPatternRegister from "../features/Order/ZyutyuHaisyaPatternRegister/ZyutyuHaisyaPatternRegister"
import ZyutyuHaisyaRegister from "../features/Order/ZyutyuHaisyaRegister/ZyutyuHaisyaRegister"
import ZyutyuHaisyaTable from "../features/Order/ZyutyuHaisyaTable/ZyutyuHaisyaTable"
// 海コン受注配車
import KaikonZyutyuHaisyaList from "../features/OrderContainer/KaikonZyutyuHaisyaList/KaikonZyutyuHaisyaList"
import KaikonZyutyuHaisyPatternList from "../features/OrderContainer/KaikonZyutyuHaisyaPatternList/KaikonZyutyuHaisyaPatternList"
import KaikonZyutyuHaisyPatternRegister from "../features/OrderContainer/KaikonZyutyuHaisyaPatternRegister/KaikonZyutyuHaisyaPatternRegister"
import KaikonZyutyuHaisyaRegister from "../features/OrderContainer/KaikonZyutyuHaisyaRegister/KaikonZyutyuHaisyaRegister"
// 運行管理
import TenkoList from "../features/TruckControl/Tenko/TenkoList"
import TenkoRegister from "../features/TruckControl/Tenko/TenkoRegister"
import UnkoKanrisyaRegister from "../features/TruckControl/UnkoKanrisya/UnkoKanrisyaRegister"
// 請求・支払管理
import AGCRoziKasimaKosokuryoHokokuRegister from "../features/Billing/AGCRoziKasimaKosokuryoHokokuRegister/AGCRoziKasimaKosokuryoHokokuRegister"
import DaiyoZyomuinTeateRegister from "../features/Billing/DaiyoZyomuinTeateMasterRegister/DaiyoZyomuinTeateMasterRegister"
import DaiyoZyomuinUriageRegister from "../features/Billing/DaiyoZyomuinUriageRegister/DaiyoZyomuinUriageRegister"
import InvoiceHeader from "../features/Billing/Invoice/InvoiceHeader/InvoiceHeader"
import InvoiceList from "../features/Billing/Invoice/InvoiceList/InvoiceList"
import MakeInvoice from "../features/Billing/Invoice/MakeInvoice/MakeInvoice"
import NinusiHokokusyoYamada from "../features/Billing/NinusiHokokusyo/NinusiHokokusyoYamada"
import MakePayment from "../features/Billing/Payment/MakePayment/MakePayment"
import PaymentList from "../features/Billing/Payment/PaymentList/PaymentList"
// 購買管理
import PurchaseBihinzaikoHaraidasiHistoryList from "../features/Purchase/Bihinzaiko/PurchaseBihinzaikoHaraidasiHistoryList"
import PurchaseBihinzaikoHaraidasiRegister from "../features/Purchase/Bihinzaiko/PurchaseBihinzaikoHaraidasiRegister"
import PurchaseBihinzaikoList from "../features/Purchase/Bihinzaiko/PurchaseBihinzaikoList"
import PurchaseBihinzaikoUkeireHistoryList from "../features/Purchase/Bihinzaiko/PurchaseBihinzaikoUkeireHistoryList"
import PurchaseBihinzaikoUkeireRegister from "../features/Purchase/Bihinzaiko/PurchaseBihinzaikoUkeireRegister"
// 乗務員管理
import ZyomuinMasterList from "../features/Driver/ZyomuinMasterList/ZyomuinMasterList"
import ZyomuinMasterRegister from "../features/Driver/ZyomuinMasterRegister/ZyomuinMasterRegister"
//import ZyomuinSyozokuMaster from "../features/Driver/ZyomuinSyozokuMaster/ZyomuinSyozokuMaster"
// 車輌管理
import SyaryoMasterList from "../features/Truck/SyaryoMasterList/SyaryoMasterList"
import SyaryoMasterRegister from "../features/Truck/SyaryoMasterRegister/SyaryoMasterRegister"
import SyaryoSyozokuMaster from "../features/Truck/SyaryoSyozokuMaster/SyaryoSyozokuMaster"
import TenkenSeibiList from "../features/Truck/TenkenSeibiList/TenkenSeibiList"
import TenkenSeibihiList from "../features/Truck/TenkenSeibihiList/TenkenSeibihiList"
// 勤怠管理
import Syukkinbo from "../features/Attendance/Syukkinbo/Syukkinbo"
import SyukkinboList from "../features/Attendance/SyukkinboList/SyukkinboList"
import ZyomuinSyukkinboList_v2 from "../features/Attendance/ZyomuinSyukkinboList_v2/ZyomuinSyukkinboList"
import ZyomuinSyukkinbo_v2 from "../features/Attendance/ZyomuinSyukkinbo_v2/ZyomuinSyukkinbo"

// 経営管理
import BihinZaikoUkebaraiList from "../features/Budget/BihinZaiko/BihinZaikoUkebaraiList"
import NinusiUriageList from "../features/Budget/KadaiKentoKaigi/NinusiUriageList"
import WeeklyReportAllList from "../features/Budget/KadaiKentoKaigi/WeeklyReportAllList"
import WeeklyReportBusyoList from "../features/Budget/KadaiKentoKaigi/WeeklyReportBusyoList"
import BudgetAchievementList from "../features/Budget/SogoYusoKaigi/BudgetAchievementList"
import BusyoBudgetAchievement from "../features/Budget/SogoYusoKaigi/BusyoBudgetAchievement"
import GrossProfitList from "../features/Budget/SogoYusoKaigi/GrossProfitList"
import SogoYusoKaigiNinusiUriageList from "../features/Budget/SogoYusoKaigi/SogoYusoKaigiNinusiUriageList"
import UriageYosanNenkan from "../features/Budget/UriageYosan/UriageYosanNenkanRegister"
import UriageYosanZensyaList from "../features/Budget/UriageYosan/UriageYosanZensyaList"
// 給与管理
// マスタ管理
import Vacation from "../features/Attendance/Vacation/Vacation"
import AyanasQuery from "../features/AyanasQuery/AyanasQuery"
import AyanasQueryQuery from "../features/AyanasQuery/Query/Query"
import AGCKosokuryoTarihuRegister from "../features/Billing/AgcKosokuryoTarihu/AGCKosokuryoTarihuRegister"
import CourseKyoriTarihuList from "../features/Billing/CourseKyoriTarihu/CourseKyoriTarihuList"
import CourseKyoriTarihuRegister from "../features/Billing/CourseKyoriTarihu/CourseKyoriTarihuRegister"
import KyoriWarimasiTarihuList from "../features/Billing/KyoriWarimasiTarihu/KyoriWarimasiTarihuList"
import KyoriWarimasiTarihuRegister from "../features/Billing/KyoriWarimasiTarihu/KyoriWarimasiTarihuRegister"
import UntinTarihuList from "../features/Billing/UntinTarihu/UntinTarihuList"
import NinusiUriageZissekiList from "../features/Budget/NinusiUriageZisseki/NinusiUriageZIssekiList"
import SyaryoKeihiDataTorikomi from "../features/Budget/SyaryoKeihi/SyaryoKeihiDataTorikomi"
import SyaryoKeihiList from "../features/Budget/SyaryoKeihi/SyaryoKeihiList"
import SyaryoSeibihiyoList from "../features/Budget/SyaryoSeibihiyoList/SyaryoSeibihiyoList"
import TukekaeZissekiList from "../features/Budget/TukekaeZissekiList/TukekaeZissekiList"
import SyaryoBetuUnkoSyusiList from "../features/Budget/syaryoBetuUnkoSyusi/SyaryoBetuUnkoSyusiList"
import AnzenKanriRegister from "../features/Driver/AnzenKanriRegister/AnzenKanriRegister"
import AnzenKanriZissiList from "../features/Driver/AnzenkanriZissiList/AnzenKanriZissiList"
import KenkoSindanRegister from "../features/Driver/KenkoSindanRegister/KenkoSindanRegister"
import TekiseiSindanList from "../features/Driver/TekiseiSindanList/TekiseiSindanList"
import TekiseiSindanZissiList from "../features/Driver/TekiseiSindanZissiList/TekiseiSindanZissiList"
import TekiseiSindanZissiRegister from "../features/Driver/TekiseiSindanZissiRegister/TekiseiSindanZissiRegister"
import ZimuinSyuroZikanList from "../features/DriverPayroll/ZimuinSyuroZikan/ZimuinSyuroZikanList"
import ZimuinSyuroZikanRegister from "../features/DriverPayroll/ZimuinSyuroZikan/ZimuinSyuroZikanRegister"
import ZyomuinKoteihiList from "../features/DriverPayroll/ZyomuinKoteihiList/ZyomuinKoteihiList"
import ZyomuinKyuyoList from "../features/DriverPayroll/ZyomuinKyuyo/ZyomuinKyuyoList"
import ZyomuinKyuyoMasterList2 from "../features/DriverPayroll/ZyomuinKyuyoMasterV2/ZyomuinKyuyoMasterList"
import ZyomuinKyuyoMasterRegister2 from "../features/DriverPayroll/ZyomuinKyuyoMasterV2/ZyomuinKyuyoMasterRegister"
import ZyomuinKyuyoV2List from "../features/DriverPayroll/ZyomuinKyuyoV2/ZyomuinKyuyoList"
import ZyomuinUnkoGeppoListV2 from "../features/DriverPayroll/ZyomuinUnkoGeppoListV2/ZyomuinUnkoGeppoListV2"
import ZyomuinUnkoGeppoV2 from "../features/DriverPayroll/ZyomuinUnkoGeppoListV2/ZyomuinUnkoGeppoV2"
import MasterBusyoList from "../features/Master/Busyo/MasterBusyoList"
import MasterBusyoRegister from "../features/Master/Busyo/MasterBusyoRegister"
import GetuziSimesyoriRegister from "../features/Master/GetuziSimesyori/GetuziSimesyoriRegister"
import MasterHinmeiList from "../features/Master/Hinmei/MasterHinmeiList"
import MasterHinmeiRegister from "../features/Master/Hinmei/MasterHinmeiRegister"
import MasterKubunList from "../features/Master/Kubun/MasterKubunList"
import MasterKubunRegister from "../features/Master/Kubun/MasterKubunRegister"
import MasterKyuzituRegister from "../features/Master/Kyuzitu/MasterKyuzituRegister"
import MasterNinusiList from "../features/Master/Ninusi/MasterNinusiList"
import MasterNinusiRegister from "../features/Master/Ninusi/MasterNinusiRegister"
import MasterNinusiSeikyuList from "../features/Master/NinusiSeikyu/MasterNinusiSeikyuList"
import MasterNinusiSeikyuRegister from "../features/Master/NinusiSeikyu/MasterNinusiSeikyuRegister"
import OsiraseList from "../features/Master/Osirase/OsiraseList"
import OsiraseRegister from "../features/Master/Osirase/OsiraseRegister"
import MasterSiharaisakiList from "../features/Master/Siharaisaki/MasterSiharaisakiList"
import MasterSiharaisakiRegister from "../features/Master/Siharaisaki/MasterSiharaisakiRegister"
import MasterSyainList from "../features/Master/Syain/MasterSyainList"
import MasterSyainRegister from "../features/Master/Syain/MasterSyainRegister"
import MasterSyainSyozokuHenkouList from "../features/Master/SyainSyozoku/SyainSyozokuHenkouList"
import MasterSyokuziteateRegister from "../features/Master/SyokuziTeate/MasterSyokuziteateRegister"
import MasterSyoteiZikanList from "../features/Master/SyoteiZikan/MasterSyoteiZIkanList"
import MasterSyuyoNinusiRegister from "../features/Master/SyuyoNinusi/MasterSyuyoNinusiRegister"
import MasterTumiorosisakiList from "../features/Master/Tumiorosisaki/MasterTumiorosisakiList"
import MasterTumiorosisakiRegister from "../features/Master/Tumiorosisaki/MasterTumiorosisakiRegister"
import MasterYosyaList from "../features/Master/Yosya/MasterYosyaList"
import MasterYosyaRegister from "../features/Master/Yosya/MasterYosyaRegister"
import BunkatuZyutyuHaisyaList from "../features/Order/BunkatuZyutyuHaisyaList/BunkatuZyutyuHaisyaList"
import BunkatuZyutyuHaisyaRegister from "../features/Order/BunkatuZyutyuHaisyaRegister/BunkatuZyutyuHaisyaRegister"
import KaikonZyutyuHaisyaTable from "../features/OrderContainer/KaikonZyutyuHaisyaTable/KaikonZyutyuHaisyaTable"
import SyaryoCountList from "../features/Truck/SyaryoCountList/SyaryoCountList"
import DezitakoDataTorikomi from "../features/TruckControl/Dezitako/DezitakoDataTorikomi"
import DezitakoKintaiKakunin from "../features/TruckControl/DezitakoKintaiKakunin/DezitakoKintaiKakunin"
import DezitakoFileDetail from "../features/TruckControl/DezitakoKintaiKakunin/DezitakoFileDetail"
import EtcDataList from "../features/TruckControl/Etc/EtcDataList"
import EtcDataTorikomi from "../features/TruckControl/Etc/EtcDataTorikomi"
import KyuyuryoDataTorikomi from "../features/TruckControl/Kyuyuryo/KyuyuryoDataTorikomi"
import KyuyuryoList from "../features/TruckControl/Kyuyuryo/KyuyuryoList"
import NenryoTankaRegister from "../features/TruckControl/NenryoTanka/NenryoTankaRegister"
import TenkoResultList from "../features/TruckControl/Tenko/TenkoResultList"
import ZyomuinbetuNenpiList from "../features/TruckControl/ZyomuinbetuNenpi/ZyomuinbetuNenpiList"

export type TPage = {
  機能名: string
  表示名?: string
  メニューコード: string
  分類名称: string
  分類コード: Tメニュー分類コード
  メニュー表示フラグ?: boolean
  Route: RouteProps
}

// pathは以下の順に格納すること
// [サイドバーからのリンクなど通常遷移URL, IDなどparameter利用時のURL...]

/**
 * トップページなど根幹ページ群
 */
export const mainPages: TPage[] = [
  {
    機能名: "トップ",
    分類名称: "トップ",
    分類コード: メニュー分類.トップ,
    メニューコード: トップメニューコード.トップ,
    メニュー表示フラグ: true,
    Route: { exact: true, path: ["/top"], component: Top },
  },
]

export const 受注配車Pages: TPage[] = [
  {
    機能名: "配車入力",
    分類名称: "受注配車",
    分類コード: メニュー分類.受注配車,
    メニューコード: 受注配車メニューコード.配車入力,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/order/haisyaregister"],
      component: HaisyaRegister,
    },
  },
  {
    機能名: "受注配車一覧",
    分類名称: "受注配車",
    分類コード: メニュー分類.受注配車,
    メニューコード: 受注配車メニューコード.受注配車一覧,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/order/zyutyuhaisyalist"],
      component: ZyutyuHaisyaList,
    },
  },
  {
    機能名: "受注配車入力",
    分類名称: "受注配車",
    分類コード: メニュー分類.受注配車,
    メニューコード: 受注配車メニューコード.受注配車入力,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/order/zyutyuhaisyaregister", "/order/zyutyuhaisyaregister/:id"],
      component: ZyutyuHaisyaRegister,
    },
  },
  {
    機能名: "配車表一覧",
    分類名称: "受注配車",
    分類コード: メニュー分類.受注配車,
    メニューコード: 受注配車メニューコード.配車表,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/order/zyutyuhaisyatable"],
      component: ZyutyuHaisyaTable,
    },
  },

  {
    機能名: "受注配車パターン一覧",
    分類名称: "受注配車",
    分類コード: メニュー分類.受注配車,
    メニューコード: 受注配車メニューコード.受注配車パターン一覧,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/order/zyutyuhaisyapatternlist"],
      component: ZyutyuHaisyaPatternList,
    },
  },
  {
    機能名: "受注配車パターン登録",
    分類名称: "受注配車",
    分類コード: メニュー分類.受注配車,
    メニューコード: 受注配車メニューコード.受注配車パターン登録,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/order/zyutyuhaisyapatternregister", "/order/zyutyuhaisyapatternregister/:id"],
      component: ZyutyuHaisyaPatternRegister,
    },
  },
  {
    機能名: "分割受注配車一覧",
    分類名称: "受注配車",
    分類コード: メニュー分類.受注配車,
    メニューコード: 受注配車メニューコード.分割受注配車一覧,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/order/bunkatuzyutyuhaisya/list"],
      component: BunkatuZyutyuHaisyaList,
    },
  },
  {
    機能名: "分割受注配車入力",
    分類名称: "受注配車",
    分類コード: メニュー分類.受注配車,
    メニューコード: 受注配車メニューコード.分割受注配車入力,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/order/bunkatuzyutyuhaisya", "/order/bunkatuzyutyuhaisya/:id"],
      component: BunkatuZyutyuHaisyaRegister,
    },
  },

  {
    機能名: "車番連絡表印刷",
    分類名称: "受注配車",
    分類コード: メニュー分類.受注配車,
    メニューコード: 受注配車メニューコード.車番連絡表印刷,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/order/SyabanRenrakuhyo"],
      component: SyabanRenrakuhyo,
    },
  },
  {
    機能名: "運送業務発注書印刷",
    分類名称: "受注配車",
    分類コード: メニュー分類.受注配車,
    メニューコード: 受注配車メニューコード.運送業務発注書印刷,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/order/UnsogyomuHatyusyo"],
      component: UnsogyomuHatyusyo,
    },
  },
]

export const 海コン受注配車Pages: TPage[] = [
  {
    機能名: "海コン 受注配車入力",
    分類名称: "海コン受注配車",
    分類コード: メニュー分類.海コン受注配車,
    メニューコード: 海コン受注配車メニューコード.海コン_受注配車一覧,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/ordercontainer/kaikonzyutyuhaisyaList"],
      component: KaikonZyutyuHaisyaList,
    },
  },
  {
    機能名: "海コン 受注配車登録",
    分類名称: "海コン受注配車",
    分類コード: メニュー分類.海コン受注配車,
    メニューコード: 海コン受注配車メニューコード.海コン_受注配車入力,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/ordercontainer/kaikonzyutyuhaisyaregister", "/ordercontainer/kaikonzyutyuhaisyaregister/:id"],
      component: KaikonZyutyuHaisyaRegister,
    },
  },
  {
    機能名: "海コン 配車表一覧",
    分類名称: "海コン受注配車",
    分類コード: メニュー分類.海コン受注配車,
    メニューコード: 海コン受注配車メニューコード.海コン_配車表,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/ordercontainer/kaikonzyutyuhaisyatable"],
      component: KaikonZyutyuHaisyaTable,
    },
  },

  {
    機能名: "海コン 受注パターン一覧",
    分類名称: "海コン受注配車",
    分類コード: メニュー分類.海コン受注配車,
    メニューコード: 海コン受注配車メニューコード.海コン_受注パターン一覧,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/ordercontainer/kaikonzyutyuhaisyapatternlist"],
      component: KaikonZyutyuHaisyPatternList,
    },
  },
  {
    機能名: "海コン 受注パターン登録",
    分類名称: "海コン受注配車",
    分類コード: メニュー分類.海コン受注配車,
    メニューコード: 海コン受注配車メニューコード.海コン_受注パターン登録,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: [
        "/ordercontainer/kaikonzyutyuhaisyapatternregister",
        "/ordercontainer/kaikonzyutyuhaisyapatternregister/:id",
      ],
      component: KaikonZyutyuHaisyPatternRegister,
    },
  },
]

export const 運行管理Pages: TPage[] = [
  {
    機能名: "点呼一覧",
    分類名称: "運行管理",
    分類コード: メニュー分類.運行管理,
    メニューコード: 運行管理メニューコード.点呼一覧,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/truckcontrol/tenko/tenkolist"],
      component: TenkoList,
    },
  },
  {
    機能名: "点呼記録",
    分類名称: "運行管理",
    分類コード: メニュー分類.運行管理,
    メニューコード: 運行管理メニューコード.点呼記録,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: [
        "/truckcontrol/tenko/tenkoregister",
        "/truckcontrol/tenko/tenkoregister/:zyomuin_id/:date/:tenko_kbn/:tenko_count",
      ],
      component: TenkoRegister,
    },
  },
  {
    機能名: "点呼結果一覧",
    分類名称: "運行管理",
    分類コード: メニュー分類.運行管理,
    メニューコード: 運行管理メニューコード.点呼結果一覧,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/truckcontrol/tenko/tenkoresultlist"],
      component: TenkoResultList,
    },
  },
  {
    機能名: "運行管理者マスタ",
    分類名称: "運行管理",
    分類コード: メニュー分類.運行管理,
    メニューコード: 運行管理メニューコード.運行管理者マスタ,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/truckcontrol/unkokanrisya/register", "/truckcontrol/unkokanrisya/register:id"],
      component: UnkoKanrisyaRegister,
    },
  },
  {
    機能名: "運行指示書",
    分類名称: "運行管理",
    分類コード: メニュー分類.運行管理,
    メニューコード: 運行管理メニューコード.運行指示書,
    メニュー表示フラグ: true,
    Route: { exact: true, path: ["/top"], component: Top },
  },
  {
    機能名: "デジタコデータ取込",
    分類名称: "運行管理",
    分類コード: メニュー分類.運行管理,
    メニューコード: 運行管理メニューコード.デジタコデータ取込,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/truckcontrol/dezitakodatatorikomi"],
      component: DezitakoDataTorikomi,
    },
  },
  {
    機能名: "ETCデータ取込",
    分類名称: "運行管理",
    分類コード: メニュー分類.運行管理,
    メニューコード: 運行管理メニューコード.ETCデータ取込,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/truckcontrol/etcdatatorikomi"],
      component: EtcDataTorikomi,
    },
  },
  {
    機能名: "ETCデータ一覧",
    分類名称: "運行管理",
    分類コード: メニュー分類.運行管理,
    メニューコード: 運行管理メニューコード.ETCデータ一覧,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/truckcontrol/etcdatatorikomilist"],
      component: EtcDataList,
    },
  },
  {
    機能名: "給油量データ取込",
    分類名称: "運行管理",
    分類コード: メニュー分類.運行管理,
    メニューコード: 運行管理メニューコード.給油量データ取込,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/truckcontrol/kyuyuryo/torikomi"],
      component: KyuyuryoDataTorikomi,
    },
  },
  {
    機能名: "給油量一覧",
    分類名称: "運行管理",
    分類コード: メニュー分類.運行管理,
    メニューコード: 運行管理メニューコード.給油量一覧,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/truckcontrol/kyuyuryolist"],
      component: KyuyuryoList,
    },
  },

  {
    機能名: "乗務員別燃費一覧",
    分類名称: "運行管理",
    分類コード: メニュー分類.運行管理,
    メニューコード: 運行管理メニューコード.乗務員別燃費一覧,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/truckcontrol/zyomuinbetunenpi/list"],
      component: ZyomuinbetuNenpiList,
    },
  },
  {
    機能名: "燃料単価登録",
    分類名称: "運行管理",
    分類コード: メニュー分類.運行管理,
    メニューコード: 運行管理メニューコード.燃料単価登録,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/truckcontrol/nenryotanka/register"],
      component: NenryoTankaRegister,
    },
  },
  {
    機能名: "デジタコ勤怠確認",
    分類名称: "運行管理",
    分類コード: メニュー分類.運行管理,
    メニューコード: 運行管理メニューコード.デジタコ勤怠確認,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/truckcontrol/digitacho/kintaiinfo"],
      component: DezitakoKintaiKakunin,
    },
  },
  {
    // 取込ファイル明細ビューア（内部調査用）。メニューには出さず、
    // デジタコ勤怠確認の日報番号リンク（local環境のみ表示）から遷移する。
    機能名: "取込ファイル明細（調査用）",
    分類名称: "運行管理",
    分類コード: メニュー分類.運行管理,
    メニューコード: 運行管理メニューコード.デジタコ勤怠確認,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/truckcontrol/digitacho/filedetail"],
      component: DezitakoFileDetail,
    },
  },
]

export const 請求支払管理Pages: TPage[] = [
  {
    機能名: "請求処理",
    分類名称: "請求・支払管理",
    分類コード: メニュー分類.請求_支払管理,
    メニューコード: 請求_支払管理メニューコード.請求処理,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/billing/invoice/makeinvoice"],
      component: MakeInvoice,
    },
  },
  {
    機能名: "請求明細一覧",
    分類名称: "請求・支払管理",
    分類コード: メニュー分類.請求_支払管理,
    メニューコード: 請求_支払管理メニューコード.請求明細一覧,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/billing/invoice/invoicelist/:id"],
      component: InvoiceList,
    },
  },
  {
    機能名: "請求書表紙",
    分類名称: "請求・支払管理",
    分類コード: メニュー分類.請求_支払管理,
    メニューコード: 請求_支払管理メニューコード.請求書表紙,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: [
        "/billing/invoice/invoiceheader",
        "/billing/invoice/invoiceheader/:id",
        "/billing/invoice/invoiceheader/:id/:cp",
      ],
      component: InvoiceHeader,
    },
  },
  {
    機能名: "支払処理",
    分類名称: "請求・支払管理",
    分類コード: メニュー分類.請求_支払管理,
    メニューコード: 請求_支払管理メニューコード.支払処理,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/billing/payment/makepayment"],
      component: MakePayment,
    },
  },
  {
    機能名: "支払明細一覧",
    分類名称: "請求・支払管理",
    分類コード: メニュー分類.請求_支払管理,
    メニューコード: 請求_支払管理メニューコード.支払明細一覧,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/billing/payment/paymentlist", "/billing/payment/paymentlist/:id"],
      component: PaymentList,
    },
  },

  {
    機能名: "荷主報告書（山田産業）",
    分類名称: "請求・支払管理",
    分類コード: メニュー分類.請求_支払管理,
    メニューコード: 請求_支払管理メニューコード.荷主報告書_山田産業,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/Billing/NinusiHokokusyo"],
      component: NinusiHokokusyoYamada,
    },
  },
  {
    機能名: "会計計上済修正データ作成",
    分類名称: "請求・支払管理",
    分類コード: メニュー分類.請求_支払管理,
    メニューコード: 請求_支払管理メニューコード.会計計上済修正データ作成,
    メニュー表示フラグ: true,
    Route: { exact: true, path: ["/top"], component: Top },
  },
  {
    機能名: "会計連携データ作成指示",
    分類名称: "請求・支払管理",
    分類コード: メニュー分類.請求_支払管理,
    メニューコード: 請求_支払管理メニューコード.会計連携データ作成指示,
    メニュー表示フラグ: true,
    Route: { exact: true, path: ["/top"], component: Top },
  },
  {
    機能名: "運賃タリフ一覧",
    分類名称: "請求・支払管理",
    分類コード: メニュー分類.請求_支払管理,
    メニューコード: 請求_支払管理メニューコード.運賃タリフ一覧,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/billing/untintarihu/list"],
      component: UntinTarihuList,
    },
  },

  {
    機能名: "大陽 乗務員売上入力",
    分類名称: "経営管理",
    分類コード: メニュー分類.請求_支払管理,
    メニューコード: 請求_支払管理メニューコード.大陽乗務員売上入力,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/billing/taiyozyomuinuriage/register"],
      component: DaiyoZyomuinUriageRegister,
    },
  },
  {
    機能名: "大陽 乗務員手当マスタ登録",
    分類名称: "経営管理",
    分類コード: メニュー分類.請求_支払管理,
    メニューコード: 請求_支払管理メニューコード.大陽乗務員手当マスタ登録,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/billing/taiyozyomuinteate/register"],
      component: DaiyoZyomuinTeateRegister,
    },
  },
  {
    機能名: "AGL鹿島ガラス高速料報告",
    分類名称: "経営管理",
    分類コード: メニュー分類.請求_支払管理,
    メニューコード: 請求_支払管理メニューコード.AGL鹿島ガラス高速料報告,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/billing/agcrozikasimakosokuryohokoku/register"],
      component: AGCRoziKasimaKosokuryoHokokuRegister,
    },
  },
  {
    機能名: "コース距離タリフ一覧",
    分類名称: "請求・支払管理",
    分類コード: メニュー分類.請求_支払管理,
    メニューコード: 請求_支払管理メニューコード.コース距離タリフ一覧,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/billing/coursekyoritarihu/list"],
      component: CourseKyoriTarihuList,
    },
  },
  {
    機能名: "コース距離タリフ登録",
    分類名称: "請求・支払管理",
    分類コード: メニュー分類.請求_支払管理,
    メニューコード: 請求_支払管理メニューコード.コース距離タリフ登録,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/billing/coursekyoritarihu/register", "/billing/coursekyoritarihu/register/:id"],
      component: CourseKyoriTarihuRegister,
    },
  },
  {
    機能名: "距離割増タリフ一覧",
    分類名称: "請求・支払管理",
    分類コード: メニュー分類.請求_支払管理,
    メニューコード: 請求_支払管理メニューコード.距離割増タリフ一覧,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/billing/kyoriwarimasitarihu/list"],
      component: KyoriWarimasiTarihuList,
    },
  },
  {
    機能名: "距離割増タリフ登録",
    分類名称: "請求・支払管理",
    分類コード: メニュー分類.請求_支払管理,
    メニューコード: 請求_支払管理メニューコード.距離割増タリフ登録,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/billing/kyoriwarimasitarihu/register", "/billing/kyoriwarimasitarihu/register/:id"],
      component: KyoriWarimasiTarihuRegister,
    },
  },
  {
    機能名: "AGL鹿島ガラス高速料タリフ",
    分類名称: "請求・支払管理",
    分類コード: メニュー分類.請求_支払管理,
    メニューコード: 請求_支払管理メニューコード.AGL鹿島ガラス高速料タリフ,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/billing/agckosokuryotarihu/register"],
      component: AGCKosokuryoTarihuRegister,
    },
  },
]

export const 購買管理Pages: TPage[] = [
  {
    機能名: "備品在庫受入一覧",
    分類名称: "購買管理",
    分類コード: メニュー分類.購買管理,
    メニューコード: 購買管理メニューコード.備品在庫受入一覧,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/purchase/bihinzaiko/ukeirelist"],
      component: PurchaseBihinzaikoList,
    },
  },
  {
    機能名: "備品在庫受入登録",
    分類名称: "購買管理",
    分類コード: メニュー分類.購買管理,
    メニューコード: 購買管理メニューコード.備品在庫受入登録,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/purchase/bihinzaiko/ukeireregister", "/purchase/bihinzaiko/ukeireregister/:id"],
      component: PurchaseBihinzaikoUkeireRegister,
    },
  },
  {
    機能名: "備品在庫受入履歴一覧",
    分類名称: "購買管理",
    分類コード: メニュー分類.購買管理,
    メニューコード: 購買管理メニューコード.備品在庫受入履歴一覧,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/purchase/bihinzaiko/ukeirehistorylist"],
      component: PurchaseBihinzaikoUkeireHistoryList,
    },
  },
  {
    機能名: "備品在庫払出一覧",
    分類名称: "購買管理",
    分類コード: メニュー分類.購買管理,
    メニューコード: 購買管理メニューコード.備品在庫払出一覧,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/purchase/bihinzaiko/haraidasilist"],
      component: PurchaseBihinzaikoList,
    },
  },
  {
    機能名: "備品在庫払出登録",
    分類名称: "購買管理",
    分類コード: メニュー分類.購買管理,
    メニューコード: 購買管理メニューコード.備品在庫払出登録,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/purchase/bihinzaiko/haraidasiregister", "/purchase/bihinzaiko/haraidasiregister/:id"],
      component: PurchaseBihinzaikoHaraidasiRegister,
    },
  },
  {
    機能名: "備品在庫払出履歴一覧",
    分類名称: "購買管理",
    分類コード: メニュー分類.購買管理,
    メニューコード: 購買管理メニューコード.備品在庫払出履歴一覧,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/purchase/bihinzaiko/haraidasihistorylist"],
      component: PurchaseBihinzaikoHaraidasiHistoryList,
    },
  },
]

export const 乗務員管理Pages: TPage[] = [
  {
    機能名: "乗務員マスタ一覧",
    分類名称: "乗務員管理",
    分類コード: メニュー分類.乗務員管理,
    メニューコード: 乗務員管理メニューコード.乗務員マスタ一覧,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/driver/zyomuinmasterlist"],
      component: ZyomuinMasterList,
    },
  },
  {
    機能名: "乗務員マスタ登録",
    分類名称: "乗務員管理",
    分類コード: メニュー分類.乗務員管理,
    メニューコード: 乗務員管理メニューコード.乗務員マスタ登録,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/driver/zyomuinmasterregister/:id"],
      component: ZyomuinMasterRegister,
    },
  },
  {
    機能名: "安全会議登録",
    分類名称: "乗務員管理",
    分類コード: メニュー分類.乗務員管理,
    メニューコード: 乗務員管理メニューコード.安全会議登録,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/driver/anzenkanriregister"],
      component: AnzenKanriRegister,
    },
  },
  // 別パス・別コンポーネントと認識させるため、メニューコードを空にして独立させている
  {
    機能名: "安全会議登録",
    分類名称: "乗務員管理",
    分類コード: メニュー分類.乗務員管理,
    メニューコード: "", // 乗務員管理メニューコード.安全会議登録,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/driver/anzenkanriregister/:id"],
      component: AnzenKanriRegister,
    },
  },
  {
    機能名: "安全会議実施一覧",
    分類名称: "乗務員管理",
    分類コード: メニュー分類.乗務員管理,
    メニューコード: 乗務員管理メニューコード.安全会議実施一覧,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/driver/anzenkanrizissilist"],
      component: AnzenKanriZissiList,
    },
  },
  {
    機能名: "適性診断登録",
    分類名称: "乗務員管理",
    分類コード: メニュー分類.乗務員管理,
    メニューコード: 乗務員管理メニューコード.適性診断対象一覧,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/driver/tekiseisindanlist"],
      component: TekiseiSindanList,
    },
  },
  {
    機能名: "適性診断実施一覧",
    分類名称: "乗務員管理",
    分類コード: メニュー分類.乗務員管理,
    メニューコード: 乗務員管理メニューコード.適性診断実施一覧,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/driver/tekiseisindanzissilist"],
      component: TekiseiSindanZissiList,
    },
  },
  {
    機能名: "適性診断実施登録",
    分類名称: "乗務員管理",
    分類コード: メニュー分類.乗務員管理,
    メニューコード: 乗務員管理メニューコード.適性診断実施登録,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/driver/tekiseisindanregister", "/driver/tekiseisindanregister/:id"],
      component: TekiseiSindanZissiRegister,
    },
  },
  {
    機能名: "健康診断登録",
    分類名称: "乗務員管理",
    分類コード: メニュー分類.乗務員管理,
    メニューコード: 乗務員管理メニューコード.健康診断登録,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/driver/kenkosindanregister"],
      component: KenkoSindanRegister,
    },
  },
  // 別パス・別コンポーネントと認識させるため、メニューコードを空にして独立させている
  {
    機能名: "健康診断登録",
    分類名称: "乗務員管理",
    分類コード: メニュー分類.乗務員管理,
    メニューコード: "", // 乗務員管理メニューコード.健康診断登録,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/driver/kenkosindanregister/:id"],
      component: KenkoSindanRegister,
    },
  },
]

export const 車輌管理Pages: TPage[] = [
  {
    機能名: "車輌台数一覧",
    分類名称: "車輌管理",
    分類コード: メニュー分類.車輌管理,
    メニューコード: 車輌管理メニューコード.車輌台数一覧,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/truck/syaryocountlist"],
      component: SyaryoCountList,
    },
  },
  {
    機能名: "車輌マスタ",
    分類名称: "車輌管理",
    分類コード: メニュー分類.車輌管理,
    メニューコード: 車輌管理メニューコード.車輌マスタ,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/truck/syaryomasterlist"],
      component: SyaryoMasterList,
    },
  },
  {
    機能名: "車輌マスタ登録",
    分類名称: "車輌管理",
    分類コード: メニュー分類.車輌管理,
    メニューコード: 車輌管理メニューコード.車輌マスタ登録,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/truck/syaryomasterregster", "/truck/syaryomasterregster/:id"],
      component: SyaryoMasterRegister,
    },
  },
  {
    機能名: "車輌所属マスタ",
    分類名称: "車輌管理",
    分類コード: メニュー分類.車輌管理,
    メニューコード: 車輌管理メニューコード.車輌所属マスタ,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/truck/syaryosyozokumaster"],
      component: SyaryoSyozokuMaster,
    },
  },
  {
    機能名: "点検整備一覧",
    分類名称: "車輌管理",
    分類コード: メニュー分類.車輌管理,
    メニューコード: 車輌管理メニューコード.点検整備一覧,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/truck/tenkenseibi/list"],
      component: TenkenSeibiList,
    },
  },
  {
    機能名: "点検整備費入力",
    分類名称: "車輌管理",
    分類コード: メニュー分類.車輌管理,
    メニューコード: 車輌管理メニューコード.点検整備費入力,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/truck/tenkenseibihinyuryoku/list"],
      component: TenkenSeibihiList,
    },
  },
]

export const 勤怠管理Pages: TPage[] = [
  {
    機能名: "出勤簿一覧",
    分類名称: "勤怠管理",
    分類コード: メニュー分類.勤怠管理,
    メニューコード: 勤怠管理メニューコード.出勤簿一覧,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/attendance/syukkinbolist"],
      component: SyukkinboList,
    },
  },
  {
    機能名: "出勤簿",
    分類名称: "勤怠管理",
    分類コード: メニュー分類.勤怠管理,
    メニューコード: 勤怠管理メニューコード.出勤簿,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/attendance/syukkinbo/:id/:date"],
      component: Syukkinbo,
    },
  },
  {
    機能名: "乗務員出勤簿一覧(新)",
    分類名称: "勤怠管理",
    分類コード: メニュー分類.勤怠管理,
    メニューコード: 勤怠管理メニューコード.乗務員出勤簿一覧_v2,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/attendance/zyomuinsyukkinbolist/v2"],
      component: ZyomuinSyukkinboList_v2,
    },
  },
  {
    機能名: "乗務員出勤簿",
    分類名称: "勤怠管理",
    分類コード: メニュー分類.勤怠管理,
    メニューコード: 勤怠管理メニューコード.乗務員出勤簿_v2,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/attendance/zyomuinsyukkinbo/v2/:id/:date"],
      component: ZyomuinSyukkinbo_v2,
    },
  },

  {
    機能名: "有給休暇管理",
    分類名称: "勤怠管理",
    分類コード: メニュー分類.勤怠管理,
    メニューコード: 勤怠管理メニューコード.有給休暇管理,
    メニュー表示フラグ: true,
    Route: { exact: true, path: ["/attendance/vacation"], component: Vacation },
  },
]

export const 経営管理Pages: TPage[] = [
  {
    機能名: "売上予算",
    分類名称: "経営管理",
    分類コード: メニュー分類.経営管理,
    メニューコード: 予算_実績メニューコード.売上予算,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/budget/uriageyosan/uriageyosannenkanregister"],
      component: UriageYosanNenkan,
    },
  },
  {
    機能名: "売上予算全社",
    分類名称: "経営管理",
    分類コード: メニュー分類.経営管理,
    メニューコード: 予算_実績メニューコード.売上予算_全社,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/budget/uriageyosan/uriageyosanzensyalist"],
      component: UriageYosanZensyaList,
    },
  },
  {
    機能名: "業績会議",
    分類名称: "経営管理",
    分類コード: メニュー分類.経営管理,
    メニューコード: 予算_実績メニューコード.業績会議_週報全社,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/budget/kadaikentokaigi/weeklyreportall"],
      component: WeeklyReportAllList,
    },
  },
  {
    機能名: "業績会議",
    分類名称: "経営管理",
    分類コード: メニュー分類.経営管理,
    メニューコード: 予算_実績メニューコード.業績会議_週報部所別,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/budget/kadaikentokaigi/weeklyreportbusyo"],
      component: WeeklyReportBusyoList,
    },
  },
  {
    機能名: "業績会議",
    分類名称: "経営管理",
    分類コード: メニュー分類.経営管理,
    メニューコード: 予算_実績メニューコード.業績会議_荷主売上一覧,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/budget/kadaikentokaigi/ninusiuriagelist"],
      component: NinusiUriageList,
    },
  },
  {
    機能名: "輸送戦略会議",
    分類名称: "経営管理",
    分類コード: メニュー分類.経営管理,
    メニューコード: 予算_実績メニューコード.総合輸送会議_予算実績,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/budget/sogoyusokaigi/budgetachievementlist"],
      component: BudgetAchievementList,
    },
  },
  {
    機能名: "輸送戦略会議",
    分類名称: "経営管理",
    分類コード: メニュー分類.経営管理,
    メニューコード: 予算_実績メニューコード.総合輸送会議_粗利益一覧,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/budget/sogoyusokaigi/grossprofitlist"],
      component: GrossProfitList,
    },
  },
  {
    機能名: "輸送戦略会議",
    分類名称: "経営管理",
    分類コード: メニュー分類.経営管理,
    メニューコード: 予算_実績メニューコード.総合輸送会議_荷主売上一覧,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/budget/sogoyusokaigi/sogoyosankaigininusiuriagelist"],
      component: SogoYusoKaigiNinusiUriageList,
    },
  },
  {
    機能名: "輸送戦略会議",
    分類名称: "経営管理",
    分類コード: メニュー分類.経営管理,
    メニューコード: 予算_実績メニューコード.総合輸送会議_部所予算実績,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/budget/sogoyusokaigi/busyobudgetachievement"],
      component: BusyoBudgetAchievement,
    },
  },

  {
    機能名: "荷主売上実績",
    分類名称: "経営管理",
    分類コード: メニュー分類.経営管理,
    メニューコード: 予算_実績メニューコード.荷主売上実績,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/budget/ninusiuriagezisseki/list"],
      component: NinusiUriageZissekiList,
    },
  },
  {
    機能名: "車輌別運行収支一覧",
    分類名称: "経営管理",
    分類コード: メニュー分類.経営管理,
    メニューコード: 予算_実績メニューコード.車輌別運行収支一覧,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/budget/syaryobetuunkosyusi/syaryobetuunkosyusilist"],
      component: SyaryoBetuUnkoSyusiList,
    },
  },
  {
    機能名: "乗務員売上一覧",
    分類名称: "経営管理",
    分類コード: メニュー分類.経営管理,
    メニューコード: 予算_実績メニューコード.乗務員売上一覧,
    メニュー表示フラグ: true,
    Route: { exact: true, path: ["/top"], component: Top },
  },
  {
    機能名: "付替実績一覧",
    分類名称: "経営管理",
    分類コード: メニュー分類.経営管理,
    メニューコード: 予算_実績メニューコード.付替実績一覧,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/budget/tukekaezisseki/list"],
      component: TukekaeZissekiList,
    },
  },
  {
    機能名: "車輌整備費用一覧",
    分類名称: "経営管理",
    分類コード: メニュー分類.経営管理,
    メニューコード: 予算_実績メニューコード.車輌整備費用一覧,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/budget/syaryoseibihiyo/list"],
      component: SyaryoSeibihiyoList,
    },
  },
  {
    機能名: "備品在庫受払表",
    分類名称: "経営管理",
    分類コード: メニュー分類.経営管理,
    メニューコード: 予算_実績メニューコード.備品在庫受払表,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/budget/bihinzaiko/ukebarailist"],
      component: BihinZaikoUkebaraiList,
    },
  },
  {
    機能名: "車輌経費データ取込",
    分類名称: "経営管理",
    分類コード: メニュー分類.経営管理,
    メニューコード: 予算_実績メニューコード.車輌経費データ取込,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/budget/syaryokeihi/torikomi"],
      component: SyaryoKeihiDataTorikomi,
    },
  },
  {
    機能名: "車輌経費一覧",
    分類名称: "経営管理",
    分類コード: メニュー分類.経営管理,
    メニューコード: 予算_実績メニューコード.車輌経費一覧,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/budget/syaryokeihi/list"],
      component: SyaryoKeihiList,
    },
  },
]

export const 給与管理Pages: TPage[] = [
  {
    機能名: "乗務員運行月報",
    分類名称: "給与管理",
    分類コード: メニュー分類.給与管理,
    メニューコード: 給与管理メニューコード.乗務員運行月報_v2,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/driverpayroll/ZyomuinUnkoGeppoV2/:geppoid/:syainid"],
      component: ZyomuinUnkoGeppoV2,
    },
  },
  {
    機能名: "乗務員運行月報一覧_v2",
    分類名称: "給与管理",
    分類コード: メニュー分類.給与管理,
    メニューコード: 給与管理メニューコード.乗務員運行月報一覧_v2,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/driverpayroll/ZyomuinUnkoGeppoListV2"],
      component: ZyomuinUnkoGeppoListV2,
    },
  },
  {
    機能名: "乗務員給与一覧",
    分類名称: "給与管理",
    分類コード: メニュー分類.給与管理,
    メニューコード: 給与管理メニューコード.乗務員給与一覧,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/driverpayroll/zyomuinkyuyo/list"],
      component: ZyomuinKyuyoList,
    },
  },

  {
    機能名: "事務員就労時間一覧",
    分類名称: "給与管理",
    分類コード: メニュー分類.給与管理,
    メニューコード: 給与管理メニューコード.事務員就労時間一覧,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/driverpayroll/zimuinsyurozikan/list"],
      component: ZimuinSyuroZikanList,
    },
  },
  {
    機能名: "事務員就労時間修正",
    分類名称: "給与管理",
    分類コード: メニュー分類.給与管理,
    メニューコード: 給与管理メニューコード.事務員就労時間修正,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: [
        "/driverpayroll/zimuinsyurozikan/register/:year/:month/:syainid/",
        "/driverpayroll/zimuinsyurozikan/register/:year/:month/:syainid/:id",
      ],
      component: ZimuinSyuroZikanRegister,
    },
  },
  {
    機能名: "乗務員固定費一覧",
    分類名称: "給与管理",
    分類コード: メニュー分類.給与管理,
    メニューコード: 給与管理メニューコード.乗務員固定費一覧,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/driverpayroll/zyomuinkoteihilist/"],
      component: ZyomuinKoteihiList,
    },
  },
  {
    機能名: "乗務員給与マスタ(新)",
    分類名称: "給与管理",
    分類コード: メニュー分類.給与管理,
    メニューコード: 給与管理メニューコード.乗務員給与マスタ_v2,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/driverpayroll/zyomuinkyuyomaster/v2/list"],
      component: ZyomuinKyuyoMasterList2,
    },
  },
  {
    機能名: "乗務員給与マスタ登録(新)",
    分類名称: "給与管理",
    分類コード: メニュー分類.給与管理,
    メニューコード: 給与管理メニューコード.乗務員給与マスタ登録_v2,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/driverpayroll/zyomuinkyuyomaster/v2/register/:id"],
      component: ZyomuinKyuyoMasterRegister2,
    },
  },
  {
    機能名: "乗務員給与一覧(新)",
    分類名称: "給与管理",
    分類コード: メニュー分類.給与管理,
    メニューコード: 給与管理メニューコード.乗務員給与一覧_v2,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/driverpayroll/zyomuinkyuyo/v2/list"],
      component: ZyomuinKyuyoV2List,
    },
  },
]

export const マスタ管理Pages: TPage[] = [
  {
    機能名: "社員マスタ",
    分類名称: "マスタ管理",
    分類コード: メニュー分類.マスタ管理,
    メニューコード: マスタ管理メニューコード.社員マスタ,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/master/syain/list"],
      component: MasterSyainList,
    },
  },
  {
    機能名: "社員マスタ登録",
    分類名称: "マスタ管理",
    分類コード: メニュー分類.マスタ管理,
    メニューコード: マスタ管理メニューコード.社員マスタ登録,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/master/syain/register", "/master/syain/register/:id"],
      component: MasterSyainRegister,
    },
  },
  {
    機能名: "社員所属変更一覧",
    分類名称: "マスタ管理",
    分類コード: メニュー分類.マスタ管理,
    メニューコード: マスタ管理メニューコード.社員所属変更一覧,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/master/syainsyozokuhenkou/list"],
      component: MasterSyainSyozokuHenkouList,
    },
  },
  {
    機能名: "部所マスタ",
    分類名称: "マスタ管理",
    分類コード: メニュー分類.マスタ管理,
    メニューコード: マスタ管理メニューコード.部所マスタ,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/master/busyo/list"],
      component: MasterBusyoList,
    },
  },
  {
    機能名: "部所マスタ登録",
    分類名称: "マスタ管理",
    分類コード: メニュー分類.マスタ管理,
    メニューコード: マスタ管理メニューコード.部所マスタ登録,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/master/busyo/register", "/master/busyo/register/:id"],
      component: MasterBusyoRegister,
    },
  },

  {
    機能名: "荷主マスタ",
    分類名称: "マスタ管理",
    分類コード: メニュー分類.マスタ管理,
    メニューコード: マスタ管理メニューコード.荷主マスタ,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/master/ninusi/list"],
      component: MasterNinusiList,
    },
  },
  {
    機能名: "荷主マスタ登録",
    分類名称: "マスタ管理",
    分類コード: メニュー分類.マスタ管理,
    メニューコード: マスタ管理メニューコード.荷主マスタ登録,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/master/ninusi/register", "/master/ninusi/register/:id"],
      component: MasterNinusiRegister,
    },
  },
  {
    機能名: "荷主請求マスタ",
    分類名称: "マスタ管理",
    分類コード: メニュー分類.マスタ管理,
    メニューコード: マスタ管理メニューコード.荷主請求マスタ,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/master/ninusiseikyu/list"],
      component: MasterNinusiSeikyuList,
    },
  },
  {
    機能名: "荷主請求マスタ登録",
    分類名称: "マスタ管理",
    分類コード: メニュー分類.マスタ管理,
    メニューコード: マスタ管理メニューコード.荷主請求マスタ登録,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/master/ninusiseikyu/register", "/master/ninusiseikyu/register/:id"],
      component: MasterNinusiSeikyuRegister,
    },
  },
  {
    機能名: "積卸先マスタ",
    分類名称: "マスタ管理",
    分類コード: メニュー分類.マスタ管理,
    メニューコード: マスタ管理メニューコード.積卸先マスタ,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/master/tumiorosisaki/list"],
      component: MasterTumiorosisakiList,
    },
  },
  {
    機能名: "積卸先マスタ登録",
    分類名称: "マスタ管理",
    分類コード: メニュー分類.マスタ管理,
    メニューコード: マスタ管理メニューコード.積卸先マスタ登録,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/master/tumiorosisaki/register", "/master/tumiorosisaki/register/:id"],
      component: MasterTumiorosisakiRegister,
    },
  },
  {
    機能名: "品名マスタ",
    分類名称: "マスタ管理",
    分類コード: メニュー分類.マスタ管理,
    メニューコード: マスタ管理メニューコード.品名マスタ,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/master/hinmei/list"],
      component: MasterHinmeiList,
    },
  },
  {
    機能名: "品名マスタ登録",
    分類名称: "マスタ管理",
    分類コード: メニュー分類.マスタ管理,
    メニューコード: マスタ管理メニューコード.品名マスタ登録,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/master/hinmei/register", "/master/hinmei/register/:id"],
      component: MasterHinmeiRegister,
    },
  },
  {
    機能名: "支払先マスタ",
    分類名称: "マスタ管理",
    分類コード: メニュー分類.マスタ管理,
    メニューコード: マスタ管理メニューコード.支払先マスタ,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/master/siharaisaki/list"],
      component: MasterSiharaisakiList,
    },
  },
  {
    機能名: "支払先マスタ登録",
    分類名称: "マスタ管理",
    分類コード: メニュー分類.マスタ管理,
    メニューコード: マスタ管理メニューコード.支払先マスタ登録,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/master/siharaisaki/register", "/master/siharaisaki/register/:id"],
      component: MasterSiharaisakiRegister,
    },
  },
  {
    機能名: "傭車マスタ",
    分類名称: "マスタ管理",
    分類コード: メニュー分類.マスタ管理,
    メニューコード: マスタ管理メニューコード.傭車マスタ,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/master/yosya/list"],
      component: MasterYosyaList,
    },
  },
  {
    機能名: "傭車マスタ登録",
    分類名称: "マスタ管理",
    分類コード: メニュー分類.マスタ管理,
    メニューコード: マスタ管理メニューコード.傭車マスタ登録,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/master/yosya/register", "/master/yosya/register/:id"],
      component: MasterYosyaRegister,
    },
  },
  {
    機能名: "食事手当マスタ",
    分類名称: "マスタ管理",
    分類コード: メニュー分類.マスタ管理,
    メニューコード: マスタ管理メニューコード.食事手当マスタ,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/master/syokuziteate/register"],
      component: MasterSyokuziteateRegister,
    },
  },
  {
    機能名: "主要荷主マスタ",
    分類名称: "マスタ管理",
    分類コード: メニュー分類.マスタ管理,
    メニューコード: マスタ管理メニューコード.主要荷主マスタ,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/master/syuyoninusi/register"],
      component: MasterSyuyoNinusiRegister,
    },
  },
  {
    機能名: "休日マスタ",
    分類名称: "マスタ管理",
    分類コード: メニュー分類.マスタ管理,
    メニューコード: マスタ管理メニューコード.休日マスタ,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/master/kyuzitu/register"],
      component: MasterKyuzituRegister,
    },
  },
  {
    機能名: "区分マスタ",
    分類名称: "マスタ管理",
    分類コード: メニュー分類.マスタ管理,
    メニューコード: マスタ管理メニューコード.区分マスタ,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/master/kubun/list"],
      // component: Top,
      component: MasterKubunList,
    },
  },
  {
    機能名: "区分マスタ登録",
    分類名称: "マスタ管理",
    分類コード: メニュー分類.マスタ管理,
    メニューコード: マスタ管理メニューコード.区分マスタ登録,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/master/kubun/register/:id"],
      // component: Top,
      component: MasterKubunRegister,
    },
  },
  {
    機能名: "所定時間マスタ",
    分類名称: "マスタ管理",
    分類コード: メニュー分類.マスタ管理,
    メニューコード: マスタ管理メニューコード.所定時間マスタ,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/master/syoteizikanlist"],
      component: MasterSyoteiZikanList,
    },
  },
  {
    機能名: "月次締め処理管理",
    分類名称: "マスタ管理",
    分類コード: メニュー分類.マスタ管理,
    メニューコード: マスタ管理メニューコード.月次締め処理管理,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/master/getuzisimesyori/register"],
      component: GetuziSimesyoriRegister,
    },
  },
  {
    機能名: "お知らせ",
    分類名称: "マスタ管理",
    分類コード: メニュー分類.マスタ管理,
    メニューコード: マスタ管理メニューコード.お知らせ一覧,
    メニュー表示フラグ: true,
    Route: {
      exact: true,
      path: ["/master/osirase/list"],
      component: OsiraseList,
    },
  },
  {
    機能名: "お知らせ登録",
    分類名称: "マスタ管理",
    分類コード: メニュー分類.マスタ管理,
    メニューコード: マスタ管理メニューコード.お知らせ登録,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/master/osirase/register", "/master/osirase/register/:id"],
      component: OsiraseRegister,
    },
  },
]

export const AyanasQueryPages: TPage[] = [
  {
    機能名: "Ayanas Query",
    分類名称: "Ayanas Query",
    分類コード: メニュー分類.Ayanas_Query,
    メニューコード: Ayanas_Queryメニューコード.Ayanas_Query,
    メニュー表示フラグ: true,
    Route: { exact: true, path: ["/ayanasquery/list"], component: AyanasQuery },
  },
  {
    機能名: "Ayanas Query 条件管理・検索結果",
    分類名称: "Ayanas Query",
    分類コード: メニュー分類.Ayanas_Query,
    メニューコード: Ayanas_Queryメニューコード.Ayanas_Query_条件管理_検索結果,
    メニュー表示フラグ: false,
    Route: {
      exact: true,
      path: ["/ayanasquery/query", "/ayanasquery/query/:queryId"],
      component: AyanasQueryQuery,
    },
  },
]

export const allPages = [
  ...mainPages,
  ...受注配車Pages,
  ...海コン受注配車Pages,
  ...運行管理Pages,
  ...請求支払管理Pages,
  ...購買管理Pages,
  ...乗務員管理Pages,
  ...車輌管理Pages,
  ...勤怠管理Pages,
  ...経営管理Pages,
  ...給与管理Pages,
  ...マスタ管理Pages,
  ...AyanasQueryPages,
]
